import React from "react";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";

const CustomPagination = ({ currentPage, totalItems, itemsPerPage, onPageChange }) => {
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  return (
    <div className="flex justify-center items-center mt-2"> {/* Centering div */}
      <Stack spacing={2}>
        <Pagination
          count={totalPages}
          page={currentPage}
          onChange={(event, value) => onPageChange(value)}
          color="primary"
          showFirstButton
          showLastButton
          siblingCount={1} // Adjust the number of sibling buttons shown
          boundaryCount={1} // Adjust the number of boundary buttons shown
        />
      </Stack>
    </div>
  );
};

export default CustomPagination;
